'use client';
import { createContext } from 'react';
const initial = {
    appliedEppoUserId: undefined,
    getFlagValue: function ({ defaultValue }) {
        return defaultValue;
    },
    getFlagOverride: function () {
        return {
            shouldUseOverride: false,
            value: null,
        };
    },
    hasProcessedUrlOverrides: false,
    hasLoadedUserInfo: true,
    isOpenFeatureFlagReady: () => true,
};
export const FeatureFlagsContext = createContext(initial);
FeatureFlagsContext.displayName = 'FeatureFlagsContext';
//# sourceMappingURL=context.js.map